import axios from '../../axios'
import store from "../store"; 

export default {
  async setMenu({ commit }, menu) {
    let {data} = await axios.post('/auth/putMenu',[menu])
    store.dispatch('lists/getListMenu');
    commit('trash_menu')
  },
}